module.exports = __webpack_public_path__ + "media/images/connected-4-46c0eff100d0f619bbe38ba41de8fa8d.jpg";